module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_2_3.8140f09f.png";